<template>
  <div style="height: 100%">
    <div class="d-flex flex-column justify-center align-center" style="height: calc(90%)">
      <lottie-animation v-cloak
                        :loop="true"
                        ref="animation"
                        :animationData="successAnimation"
                        :autoPlay="false"
                        style="max-width: 200px"></lottie-animation>
      <div class="pa-4 d-flex flex-column align-center text-center">
        <div class="text-body-1">{{$t('successReservation')}}</div>
      </div>
      <v-btn @click="goto" width="90%" dark>{{$t('Back')}}</v-btn>
    </div>
  </div>
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import successAnimation from '@/assets/Success.json'
import GlobalConfig from "../GlobalSettings";
import {getUserList} from "../repository/api";
export default {
  components: {LottieAnimation},
  data: function () {
    return {
      show: false,
      successAnimation,
      Config: GlobalConfig,
    };
  },
  props: {
  },
  async mounted() {
    const subDomain = location.hostname.split('.')[0]
    const testDomains = ['localhost', 'aaden-reservation-front']
    const host = testDomains.includes(subDomain) ? 'innerken'
        : subDomain
    const restaurantInfo = (await getUserList()).find(it => it.subDominName.toLowerCase() === host.toLowerCase())
    if (restaurantInfo?.id && restaurantInfo.id.toString() === '6015') {
      this.inject6015GTM()
    }
    if (restaurantInfo?.id && restaurantInfo.id.toString() === '6083') {
      this.injectGTM()
    }
    setTimeout(() => {
      this.$refs.animation.play()
      setTimeout(() => {
        this.show = true
      }, 1000)
    }, 1000)
  },
  methods: {
    injectGTM() {
      // 检查是否已经注入
      if (window.dataLayer) return
      console.log('injectGTM')
      // 注入head部分的script
      const script = document.createElement('script')
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-5B2XBC4M');`
      document.head.appendChild(script)

      // 注入noscript部分
      const noscript = document.createElement('noscript')
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5B2XBC4M"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`
      document.body.insertBefore(noscript, document.body.firstChild)
    },
    inject6015GTM() {
      // 检查是否已经注入
      if (window.dataLayer) return
      console.log('injectGTM')
      // 注入head部分的script
      const script = document.createElement('script')
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NRCHVNQC');`
      document.head.appendChild(script)

      // 注入noscript部分
      const noscript = document.createElement('noscript')
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRCHVNQC"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`
      document.body.insertBefore(noscript, document.body.firstChild)
    },
    goto () {
      this.$router.push('/')
    }
  },
}
</script>

<style scoped>

</style>
